<template>
    
  <BaseCardContentOnly :isLoading="[getCreditControlLoading]">
    
    <template #title>Payment</template>

    <template #content>

      <v-row>

        <BaseLabelAndInfo width="4">
          <template #label>Payment Method</template>
          <template #value>{{getCreditControl.payment_method | customPlaceholder}}</template>
        </BaseLabelAndInfo>

        <BaseLabelAndInfo width="8">
          <template #label>Most Recent Invoice Date</template>
          <template #value>{{getCreditControl.most_recent_invoice_date | formatDateWithoutTime}}</template>
        </BaseLabelAndInfo>

      </v-row>

      <v-row>
        <BaseLabelAndInfo>
          <template #label>Most Recent Payment</template>
          <template #value>{{getCreditControl.most_recent_payment_date | formatDateWithoutTime}}</template>
        </BaseLabelAndInfo>
      </v-row>

      <v-row>
        <BaseLabelAndInfo>
          <template #label>Last DD Failed Reason</template>
          <template #value>{{getCreditControl.last_dd_failed_reason | customPlaceholder}}</template>
        </BaseLabelAndInfo>
      </v-row>

      <v-row>
        <BaseLabelAndInfo>
          <template #label>Last DD Failed Date</template>
          <template #value>{{getCreditControl.last_dd_failed_date | formatDateWithoutTime}}</template>
        </BaseLabelAndInfo>
      </v-row>

    </template>

  </BaseCardContentOnly>

</template>

<script>

  import { mapGetters } from 'vuex';

  export default {

    computed: {
      ...mapGetters('creditControl',['getCreditControl','getCreditControlLoading']),
    },

  }

</script>

<style lang="scss" scoped></style>
